"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <summary>
/// Bracket a root for the target function by creating and continuously
/// expanding an interval around the <paramref name="initial"/> point
/// until the interval is known to contain at least one root.  An
/// interval is determined to contain at least one root when the
/// function evaluation at the inteval endpoints are oppisite signs.
/// </summary>
function bracketOut(rootFunction, lower, initial, upper, maximumIterations) {
    var a = initial;
    var b = a;
    var fa;
    var fb;
    var n = 0;
    var factor = Math.abs(a * .10);
    var change = 0.0;
    do {
        n += 1;
        change += factor;
        a = Math.max(a - change, lower);
        b = Math.min(b + change, upper);
        fa = rootFunction(a);
        fb = rootFunction(b);
    } while ((fa * fb > 0.0) && (n < maximumIterations));
    if (n >= maximumIterations) {
        throw new Error("The initial bounds do not bracket a root.");
    }
    return [a, b];
}
exports.bracketOut = bracketOut;
